import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductsComponent } from './products/products.component';
import { CartComponent } from './cart/cart.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductCategoryComponent } from './product-category/product-category.component';
import { FavoritesComponent } from './favorites/favorites.component';
import { CheckoutComponent } from './checkout/checkout.component';

const routes: Routes = [
  {path:'', redirectTo: 'products-list', pathMatch: 'full'},
  {path:'products-list', component : ProductListComponent},
  {path:'products', component : ProductsComponent},
  {path:'cart', component : CartComponent},
  {path:'product/:id', component : ProductDetailsComponent},
  {path:'product-category', component : ProductCategoryComponent},
  {path:'my-favourite', component : FavoritesComponent},
  {path:'checkout', component : CheckoutComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
